import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { HotjarService } from './hotjar.service';

export interface TokenResponse {
  result: Token
}

export interface Token {
  exp: string,
  token: string
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.baseUrl;
  environment: any;
  redirectUrl = ''
  private authenticationStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isAuthenticated$: Observable<boolean> = this.authenticationStatus.asObservable();

  private adminStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isAdminRole$: Observable<boolean> = this.adminStatus.asObservable();

  private nonAdminStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isNonAdminRole$: Observable<boolean> = this.nonAdminStatus.asObservable();
  countryName: any;

  private userRoleStatus: BehaviorSubject<boolean> =new BehaviorSubject<boolean>(false);
  isUserRole$: Observable<boolean> = this.userRoleStatus.asObservable();
  userRolesArray=[];
  role = 'Channel Sales and Marketing';
  roleStatus: boolean = false;
  is2in1 = false;
  isloading: boolean = true

  constructor(private http: HttpClient,
              private commonService: CommonService,
              private hotjarService : HotjarService,
              private router: Router) { }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  public setToken(token) {
     localStorage.setItem('token', token);
  }

  getAuthorized(body) {
    return this.http.post<TokenResponse>(this.baseUrl + '/services/auth/api/clients/auth/me', body)
  }

  fecthUserInfoApi() {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/me');
  }

  fetchConfigurations() {
    return this.http.get<any>(this.baseUrl + '/services/sc/api/v1/user/configurations');
  }

  setRedirectUrl(url) {
    this.redirectUrl = url;
  }
  userRoleApi() {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/user_roles'
    );
  }

  userInformation(): any {
    this.is2in1 = false;
    this.isloading = true
    this.authenticationStatus.next(false)
    this.adminStatus.next(false);
    this.nonAdminStatus.next(false);

    const userInfoApi = this.fecthUserInfoApi();
    const configurationsApi = this.fetchConfigurations();

    userInfoApi.subscribe((userInfoResponse) => {

      const res = userInfoResponse;
      this.countryName=userInfoResponse?.result?.organization?.country

      // redirection based on roles
      if(res.result.role !== 'channel') {
        this.commonService.storeEmail(res)
        this.adminStatus.next(true);
        if (!this.redirectUrl.includes('admins')) {
          this.router.navigate(['/admins'])
        } else {
          this.router.navigate([this.redirectUrl])
        }
      } else {
        this.hotjarService.loadHotjar()
        configurationsApi.subscribe(configResponse => {
          this.is2in1 = configResponse.result.is_2in1_organization;
          this.environment = configResponse?.result?.environment;
          this.nonAdminStatus.next(true);
          if (this.is2in1) {
            this.router.navigate(['/qrcode'])
          } else {
            if (this.redirectUrl.includes('admins') || this.redirectUrl.includes('qrcode')) {
              this.router.navigate(['/dashboard'])
            } else {
              this.router.navigateByUrl(this.redirectUrl)
            }
          }
          this.commonService.getUserInfo(res, configResponse);
        })
      }
      setTimeout(() => {
        this.isloading = false
      }, 1000)
      this.authenticationStatus.next(true);
    },
    (err) => {
      this.isloading = false
      this.authenticationStatus.next(false)
      if(err.status === 401) {
        window.location.href = err.error.redirect_url;
      }
    })
  }

  getUserRoles() {
    const userRole = this.userRoleApi();
      userRole.subscribe((res) => {
        if(res.result_status){
          this.userRolesArray = res.result.roles
          if (this.userRolesArray.length == 1 && res.result.roles.includes(this.role)) {
            this.userRoleStatus.next(true)
            this.roleStatus = true;
          }
        }
      });

  }

  getSalesRole() {
    if (this.roleStatus) {
        return this.role;
    } else {
        return 
    }
  }

  get isAuthenticated() {
    return this.authenticationStatus.getValue();
  }

  get isAdmin() {
    return this.adminStatus.getValue();
   }

   getCountryName(){
    return this.countryName
   }

   getPreferences() {
    return this.http.get<any>(this.getBaseUrl(this.baseUrl+'/api/portal/v2/preferences'));
   }

   public getBaseUrl(baseUrl: string): string {
    let url = baseUrl.replace('lfpsc4ch.', '');
    url = url.replace('/v1', '');
    return url;
}

  userInformationAPIIsLoading() {
    return this.isloading
  }
}
